import { useSelector } from 'react-redux';

import {
  getUntruncatedPullRequestDiffFileCount,
  getPullRequestDiffLinesCount,
} from 'src/redux/pull-request/selectors';

export const useUntruncatedDiffCounts = () => {
  const untruncatedDiffFileCount = useSelector(
    getUntruncatedPullRequestDiffFileCount
  );
  const untruncatedPullRequestLinesChanged = useSelector(
    getPullRequestDiffLinesCount
  );

  return { untruncatedDiffFileCount, untruncatedPullRequestLinesChanged };
};
